import { render, staticRenderFns } from "./CmgOrderStatusBar.vue?vue&type=template&id=e3fdbb18&scoped=true&lang=pug&"
import script from "./cmg-order-status-bar.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-status-bar.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderStatusBar.vue?vue&type=style&index=0&id=e3fdbb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fdbb18",
  null
  
)

export default component.exports